module.exports = __webpack_public_path__ + "media/bootstrap-icons/text-center-20b47993.svg";